import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {}

export const getters = {}

export const mutations = {
  CACHE_GROUPS(state, groups) {
    state.cached = groups
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchOptionsSellers(context, query) {
    return axios.get(`${serverUrl}/APIv1/sellers`).then((response) => {
      return response.data
    })
  },

}